var buttons = document.querySelectorAll('[data-show-variant]');

buttons.forEach(function(button) {
    button.addEventListener('click', function() {
        var container = button.closest('.product-form-inputs');

        if (container) {
            var labels = container.querySelectorAll('.variant-input.input-hide');

            labels.forEach(function(label) {
                label.classList.toggle('d-none');
            });

            button.classList.toggle('d-none');
            var otherButton = container.querySelector('[data-show-variant]:not(#' + button.id + ')');
            if (otherButton) {
                otherButton.classList.toggle('d-none');
            }
        }
    });
});


const shortDescription = document.getElementById('short-description');
const fullDescription = document.getElementById('full-description');
const readMoreButton = document.querySelector('.read-more-button');
const hideButton = document.querySelector('.hide-button');

readMoreButton.addEventListener('click', function() {
    shortDescription.classList.add('d-none');
    fullDescription.classList.remove('d-none');
    hideButton.classList.remove('d-none');
    readMoreButton.classList.add('d-none');
});

hideButton.addEventListener('click', function() {
    shortDescription.classList.remove('d-none');
    fullDescription.classList.add('d-none');
    hideButton.classList.add('d-none');
    readMoreButton.classList.remove('d-none');
});

document.addEventListener('DOMContentLoaded', function() {
	const layoutWrap = document.querySelector('.page-layout__wrap');
	const layoutContent = document.querySelector('.page-layout__content');
	const layoutSidebar = document.querySelector('.page-layout__sidebar');

	if (!layoutWrap || !layoutContent || !layoutSidebar) return;

	const mediaQuery = window.matchMedia('(max-width: 1023px)');

	function handleDomOrder(e) {
		if (e.matches) {
			layoutWrap.insertBefore(layoutSidebar, layoutContent);
		} else {
			layoutWrap.insertBefore(layoutContent, layoutSidebar);
		}
	}

	handleDomOrder(mediaQuery);

	mediaQuery.addEventListener('change', handleDomOrder);
});
